var modules_3f9ccc85 = {"appBanner":"MainContent_module_appBanner__e35e5998","storesBanner":"MainContent_module_storesBanner__e35e5998","contactsBanner":"MainContent_module_contactsBanner__e35e5998"};
import "../../../assets/CUSAV90J.css";

export { modules_3f9ccc85 as default };
//# sourceMappingURL=MainContent.module.less.js.map
